import { IBondGrossMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_DELTA_LINKED_MARKET';

export type IReportGrossDeltaLinkedMarketItem = IBondGrossMarketReport & { __isSelected: boolean };
